export default `
<svg 
  aria-hidden="true"
  aria-label="sparkle-single-small"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
<path 
  fill-rule="evenodd" 
  clip-rule="evenodd" 
  d="M12 4C12.2126 4 12.4574 4.12894 12.5103 4.41082C12.8635 6.29436 13.6254 7.89014 14.7951 9.10207C15.9639 10.3131 17.5509 11.1524 19.5749 11.5066C20.1423 11.6055 20.1411 12.3944 19.5749 12.4934C17.5509 12.8476 15.9639 13.6869 14.7951 14.8979C13.6254 16.1099 12.8635 17.7056 12.5103 19.5891C12.4574 19.871 12.2126 20 12 20C11.7874 20 11.5426 19.8711 11.4897 19.5892C11.1365 17.7056 10.3746 16.1099 9.20494 14.898C8.0361 13.687 6.44906 12.8478 4.42511 12.4934C3.85766 12.3944 3.85893 11.6056 4.42512 11.5066C6.44907 11.1524 8.0361 10.3131 9.20493 9.10207C10.3746 7.89014 11.1365 6.29445 11.4897 4.4109C11.5426 4.12903 11.7874 4 12 4Z" 
  fill="currentColor"
/>
</svg>
`;
